import { atom, useAtom } from "jotai";

import { type PnlCardProps } from "#/types/pnlCard";

// Single source of truth: null = hidden, object = visible + data
export const sharePnlCardsModalAtom = atom<PnlCardProps | null>(null);
// Derived atom for boolean show/hide
export const showSharePnlCardsModalAtom = atom(
  (get) => get(sharePnlCardsModalAtom) !== null,
);
export const useSharePnlCardsModal = () => {
  const [modalData, setModalData] = useAtom(sharePnlCardsModalAtom);
  const [isOpen] = useAtom(showSharePnlCardsModalAtom);

  const open = (data: PnlCardProps) => {
    setModalData(data);
  };
  const close = () => {
    setModalData(null);
  };

  return {
    isOpen,
    modalData,
    open,
    close,
  };
};
